import { observer } from "mobx-react-lite";
import React from "react";
import { useStore } from "../../app/stores/store";
import { Card, Grid, Header, Tab } from "semantic-ui-react";
import ProfileCard from "./ProfileCard";
import { useTranslation } from 'react-i18next'; // Add this import for i18n

export default observer(function ProfileFollowings() {
    const {profileStore} = useStore();
    const {profile, followings, loadingFollowings, activeTab} = profileStore;
    const { t } = useTranslation(); // Initialize translation hook

    return (
      <Tab.Pane loading={loadingFollowings}>
        <Grid>
          <Grid.Column width={16}>
            <Header 
              floated='left' 
              icon='user' 
              content={activeTab === 2 
                ? t('profileFollowings.peopleUserIsFollowing', { fullName: profile?.fullName })
                : t('profileFollowings.peopleFollowingUser', { fullName: profile?.fullName })
              } 
            />
          </Grid.Column>
          <Grid.Column width={16}>
            <Card.Group itemsPerRow={4}>
              {followings.map(profile => (
                <ProfileCard key={profile.userID} profile={profile} />
              ))}
            </Card.Group>
          </Grid.Column>
        </Grid>
      </Tab.Pane>
    )
  })